import React, { Fragment } from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';
import plural from 'pluralize';
import MeasurementTypeText from '~/components/measurementTypeText/measurementTypeText';
import IngredientTypeText from '~/components/ingredientTypeText/ingredientTypeText';

const IngredientSummaryCard = ({ className, ingredient }) => {
  const { type, measurementType, products, customsName, isTracked, amountOnHand } = ingredient;
  return (
    <Card data-qa="ingredient-summary" className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Summary</h3>
      {customsName &&
        customsName.length && (
          <Fragment>
            <h4 className="table-header mv0">Name for customs report</h4>
            <p>{customsName}</p>
          </Fragment>
        )}
      {isTracked && (
        <Fragment>
          <h4 className="table-header mv0">Amount on Hand</h4>
          <p>
            {amountOnHand} <MeasurementTypeText capitalise type={measurementType} />
          </p>
        </Fragment>
      )}
      <h4 className="table-header mv0">Type</h4>
      <p>
        <IngredientTypeText capitalise type={type} />
      </p>
      <h4 className="table-header mv0">Measured in</h4>
      <p>
        <MeasurementTypeText capitalise type={measurementType} />
      </p>
      <h4 className="table-header mv0">Used in</h4>
      <p>
        {products.length} {plural('product', products.length)}
      </p>
    </Card>
  );
};

export default IngredientSummaryCard;



// WEBPACK FOOTER //
// ./src/components/ingredientSummaryCard/ingredientSummaryCard.jsx